import extendNode from '../extendNode.mjs'
import useCatRootModuleNode from '../_CAT_ROOT_MODULE/useCatRootModuleNode.jsx'
import PropertiesPane from './PropertiesPaneCatRootAm.jsx'
import meta from './metaCatRootAm.mjs'

export default () => {
    const CatRootModuleNode = useCatRootModuleNode()

    return extendNode(CatRootModuleNode, {
        ...meta,
        PropertiesPane,

        canLinkType(map, node, type) {
            return /^([AD]O|AMA[RI]|CDT)$/.test(type)
        },

        menuItemsInsertConcept(map, node) {
            return [
                {type: 'DO'},
                {type: 'AO'},
                {type: 'AMAR'},
                {type: 'AMAI'},
            ]
        },

        menuItemsInsertProduct(map, node) {
            return [
                {type: 'DO'},
                {type: 'AO'},
                {type: 'AMAR'},
                {type: 'AMAI'},
                {type: 'CDT'},
            ]
        },
    })
}
